import script from "./BpmnProcessModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BpmnProcessModal.vue?vue&type=script&setup=true&lang=js"

import "./BpmnProcessModal.vue?vue&type=style&index=0&id=5428718c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5428718c"]])

export default __exports__